var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"logo-neadoo",attrs:{"src":"https://neadoo.pl/wp-content/uploads/2019/07/logo.svg","alt":"","srcset":""}})])}]

export { render, staticRenderFns }